import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
const WeaklyBookings = ({ t }) => {
  const data = [
    { name: t("sat"), trips: 400 },
    { name: t("sun"), trips: 300 },
    { name: t("mon"), trips: 600 },
    { name: t("tue"), trips: 500 },
    { name: t("wed"), trips: 700 },
    { name: t("thu"), trips: 800 },
  ];
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="px-2 py-1 text-sm text-white rounded-md shadow bg-primary">
          {`${payload[0].value} ${t("journey")}`}
        </div>
      );
    }

    return null;
  };
  return (
    <section className="border-[#D1A8551A] w-full border  rounded-2xl  p-3 xl:p-6 shadow-md mainLinear">
      <h2 className="my-3 font-semibold">{t("weaklyBookings")}</h2>
      <div className="h-[220px] " style={{ minWidth: "100px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid stroke="#374151" strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 12, fill: "#9ca3af" }}
              interval={0}
            />
            <YAxis
              tick={{ fontSize: 12, fill: "#9ca3af", textAnchor: "end", dx: -20 }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="trips"
              stroke="#d1a855"
              strokeWidth={3}
              activeDot={{ r: 8, fill: "#d1a855" }}
              dot={{ fill: "#d1a855" }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};

export default WeaklyBookings;
